import React, { useState, useCallback } from 'react'
import { Field, Input } from '@chakra-ui/react'
import { validateCardHolder } from '../validators/cardValidator'

export const CardHolderInput = ({ onChange }) => {
  const [value, setValue] = useState('')
  const [error, setError] = useState(null)
  const [touched, setTouched] = useState(false)

  const handleChange = useCallback(
    (e) => {
      const newValue = e.target.value
      setValue(newValue)
      // エラーがある場合のみクリア
      if (error) {
        setError(null)
      }
      // 親に通知
      const validationError = validateCardHolder(newValue)
      if (onChange) {
        onChange(newValue, !validationError)
      }
    },
    [error, onChange],
  )

  const handleBlur = useCallback(() => {
    setTouched(true)
    const validationError = validateCardHolder(value)
    setError(validationError)
    // 親に最新の状態を通知
    if (onChange) {
      onChange(value, !validationError)
    }
  }, [value, onChange])

  return (
    <Field.Root invalid={touched && !!error}>
      <Field.Label fontSize="xs" fontWeight="600" mb="8px" color="externalPayment.cardInputText">
        カード名義人
      </Field.Label>
      <Input
        type="text"
        value={value}
        onChange={handleChange}
        onBlur={handleBlur}
        placeholder="半角アルファベットで入力してください"
        bg="bg.secondary"
        borderRadius="4px"
        h="40px"
        fontSize="3xs"
        fontWeight="300"
        borderWidth="1px"
        borderColor="externalPayment.cardInputBorder"
        _placeholder={{ color: 'externalPayment.cardInputPlaceholder' }}
        _hover={{ borderColor: 'externalPayment.cardInputBorderHover' }}
        _focus={{ borderColor: 'externalPayment.cardInputBorderFocus', boxShadow: 'none' }}
      />
      {touched && error && <Field.ErrorText>{error}</Field.ErrorText>}
    </Field.Root>
  )
}
